import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { MarkersInfoColors } from "../WinLineInfoMarkers";

export class LuckySeven_2Screen extends SlotGameType1_2Screen {
    protected override panelFactory: IPanelFactory = new LuckySevenPanelFactory();
    protected override helpFactory: IHelpFactory = new LuckySevenHelpFactory();
    protected override panelColor: ButtonColors = {
        backgroundButtonColor: "linear-gradient(rgb(40,3,64),rgb(84,4,140),rgb(84,4,140),rgb(40,3,64)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        linearColor: "linear-gradient(to left , transparent, LightPink,transparent ) 0 10 100%",
    }

    //LED COLOR
    protected override ColorLed: string = "173,83,255\n";
    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "LuckySeven");
        this.spinnableReelsParams.topBorderWidth = 0;
        this.spinnableReelsParams.bottomBorderWidth = 0;
    }

    //SEND COLOR FOR RSA 
    protected override color: RewardColor =
        {
            color: "#F1F0C9",
            coloroutherStroke: "black",
            colorinnerStroke: "#9F8DF4",
        }

    protected override colorLineMarkers: MarkersInfoColors =
        {
            MarkerbackgroundColor: "linear-gradient(90deg, rgb(0,0,0),rgb(84,4,140),rgb(84,4,140),rgb(0,0,0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };
}

//Panel Colorized
class LuckySevenPanelFactory implements IPanelFactory {
    public CreateNewPanel(params: PanelParams): Panel {
        return new LuckySevenPanel(params);
    }
}

class LuckySevenPanel extends Panel {
    protected override ButtonBackground(): ButtonColors {
        let color: ButtonColors = {
            backgroundButtonColor: "linear-gradient(rgb(0,0,0),rgb(84,4,140),rgb(84,4,140),rgb(0,0,0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            linearColor: "linear-gradient(to left , transparent, LightPink,transparent ) 0 10 100%",
        };

        return color;
    }

}
class LuckySevenHelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new LuckySevenHelp(params);
    }
}

class LuckySevenHelp extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(40,3,64),rgb(84,4,140),rgb(84,4,140),rgb(40,3,64)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };
        return color;
    }
}
